export default "__VITE_ASSET__DmwIOsLV__";